const func = $target => {
	window.loader.key('swiper', function() {
		if ($target.find('.swiper-slide').length > 1) {
			var productsSlider = new Swiper($target.find('.swiper-container'), {
				slidesPerView: 1,
				spaceBetween: 15,
				effect: 'slide',
				navigation: {
					nextEl: '.swiper-container-wrap .swiper-button-next',
					prevEl: '.swiper-container-wrap .swiper-button-prev'
				},
				breakpointsInverse: true,
				breakpoints: {
					768: {
						// md (and up) config here
						slidesPerView: 2
					},
					992: {
						// lg (and up) config here
						slidesPerView: 2
					},
					1200: {
						// xl (and up) config here
						slidesPerView: 2
					}
				},
				on: {
					init: function() {
						$target.find('.fade').addClass('show');
					}
				}
			});
		} else {
			$target.find('.swiper-container').addClass('show');
		}
	});
	window.loader.key('matchheight', function() {
		$target.find('.swiper-slide').matchHeight({
			byRow: false
		});
	});

};

export default func;
